import { NavigationColumnStoryblok } from 'storyblok-types';
import { INavigationItem } from 'modules/stroyblok/types';
import { AppearanceAnimationBlock } from '../animation';
import { ColumnItem } from './ColumnItem';
import styles from './Column.module.css';

export const Column = ({
  columnItem,
  itemParentTitle,
}: {
  columnItem: NavigationColumnStoryblok | null;
  itemParentTitle: string;
}) => {
  return !columnItem ? null : (
    <AppearanceAnimationBlock
      keyVal={columnItem._uid}
      el="li"
      className={styles.root}
    >
      {columnItem.items?.map((item: INavigationItem) => (
        <ColumnItem
          key={item._uid}
          navItem={item as INavigationItem}
          itemParentTitle={itemParentTitle}
        />
      ))}
    </AppearanceAnimationBlock>
  );
};
